
import * as assetRuntime$IyPiXGJmpW from '/app/src/providers/asset.provider.ts'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "asset",
  "domains": [],
  "alias": {
    "/token2049": "/res/img/events/token2049",
    "/hk2024": "/res/img/events/hk2024"
  },
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['asset']: { provider: assetRuntime$IyPiXGJmpW, defaults: undefined }
}
        